(function fixSlideshowMobile() {
  function applyFix() {
    if (window.innerWidth > 749) return;

    const section = document.querySelector('.slideshow-section');
    if (!section) return;

    const containers = section.querySelectorAll(
      'slideshow-component, slideshow-slides, .slideshow'
    );
    containers.forEach(el => {
      el.style.removeProperty('height');
      el.style.removeProperty('min-height');
      el.style.height = 'auto';
      el.style.minHeight = '0';
    });

    const slides = section.querySelectorAll(
      'slideshow-slide, slideshow-slide .media, slideshow-slide .slideshow__image'
    );
    slides.forEach(el => {
      el.style.removeProperty('height');
      el.style.height = '100%';
    });

    const imgs = section.querySelectorAll('slideshow-slide img');
    imgs.forEach(img => {
      img.style.position = 'absolute';
      img.style.top = '0';
      img.style.left = '0';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
    });
  }

  document.addEventListener('DOMContentLoaded', applyFix);
  window.addEventListener('load', applyFix);
  window.addEventListener('resize', applyFix);
  document.addEventListener('slideshow:change', applyFix);
})();